import React from 'react'
import LeftSideBar from '../../components/LeftSideBar';
import Title from '../../components/Title';

export const GST_Classification_Services = () => {
    return (
        <div className='services_main_wrapper'>
            <div className='container'>
                <div className='row mt-5 mb-5'>
                    <div className='col-md-3  column_height'>
                        <LeftSideBar />
                    </div>
                    <div className='col-md-9'>
                        <div className='right_side_content'>
                            <div className='section_main_title gst_classification_title d-flex align-items-center justify-content-between'>
                                <div className='title_and_icon d-flex align-items-center'>
                                    <img src='/images/gst_classification_services.png'></img>
                                    <Title text="GST Classification Services" className="custom-heading" />
                                </div>
                                 <ul className='d-flex align-items-center'>
                                    <li className='green'>accuracy</li>
                                    <li className='orange'>clarity</li>
                                    <li className='light-blue'>compliance</li>
                                </ul>
                            </div>
                            <div className='discriptions'>
                                <p>The introduction of GST in India has simplified the tax system but added a layer of complexity regarding the classification of goods and services. Proper GST classification is critical to determine the correct tax rates, avail exemptions, and maintain compliance with GST regulations. At <b>Vanani & Associates,</b> our GST Classification Services are tailored to help businesses navigate these complexities with precision and accuracy.</p>
                            </div>
                           <div className='check_list_wrap mt-2 icon_img'>
                                <ul className='row'>
                                    <h4 className='mt-3 mb-3'>Why GST<sapn className="key_features"> Classification Is Important</sapn></h4>
                                    <div className='col-md-6 mb-3'>
                                        <li>
                                            <div className='d-flex align-items-start gap-3 p-3'>
                                                <img src='images/tax-calculate.png' width="65"></img>
                                                <p><strong>Accurate Tax Calculation:</strong>Correct classification ensures the applicable GST rates are applied, avoiding overpayment or underpayment.</p>
                                            </div>
                                        </li>
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                        <li>
                                            <div className='d-flex align-items-start gap-3 p-3'>
                                                <img src='images/compliance_1.png' width="55"></img>
                                                <p><strong>Legal Compliance:</strong>Prevents penalties, interest, or disputes arising from misclassification.</p>
                                            </div>
                                        </li>
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                        <li>
                                            <div className='d-flex align-items-start gap-3 p-3'>
                                                <img src='images/input-taxcredit.png' width="55"></img>
                                                <p><strong>Input Tax Credit (ITC):</strong>Facilitates accurate claims and ensures the optimization of ITC benefits.</p>
                                            </div>
                                        </li>
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                        <li>
                                            <div className='d-flex align-items-start gap-3 p-3'>
                                                <img src='images/operational-efficiency-visual.webp' width="70"></img>
                                                <p><strong>Operational Efficiency:</strong>Streamlines invoicing, return filing, and tax reporting.</p>
                                            </div>
                                        </li>
                                    </div>
                                </ul>
                            </div>

                            <section className="gst-infographic">
                                <h4 className='mb-4'>Our <sapn className="key_features">GST Classification Services</sapn></h4>

                                <div className="gst-wrapper">

                                    {/* 1 */}
                                    <div className="gst-card">
                                    <div className="gst-icon">
                                        <img src="/images/Identification_goods.jpg" alt="Identification" />
                                    </div>
                                    <div className="gst-content">
                                        <h3>1. Identification of Goods and Services</h3>
                                        <p>We help businesses identify whether their offerings fall under <strong>goods</strong>, <strong>services</strong>, or <strong>neither</strong>, as per CGST Act, 2017.</p>
                                        <ul>
                                        <li>Ensuring clarity in distinguishing between goods and services.</li>
                                        <li>Categorizing items as taxable, non-taxable, exempt, or concessional.</li>
                                        </ul>
                                    </div>
                                    </div>

                                    {/* 2 */}
                                    <div className="gst-card reverse">
                                    <div className="gst-icon">
                                        <img src="/images/mixeda.webp" alt="Composite Supplies" />
                                    </div>
                                    <div className="gst-content">
                                        <h3>2. Classification of Composite and Mixed Supplies</h3>
                                        <p>Some supplies involve a combination of goods and services, making classification challenging.</p>
                                        <ul>
                                        <li><strong>Composite Supplies:</strong> Naturally bundled supplies where one is a principal supply.</li>
                                        <li><strong>Mixed Supplies:</strong> Multiple independent supplies sold together for a single price. Our experts determine the correct classification and tax liability for such transactions, ensuring compliance with GST provisions.</li>
                                        </ul>
                                    </div>
                                    </div>

                                    <div className="gst-card">
                                    <div className="gst-icon">
                                        <img src="/images/hsn.webp" alt="HSN/SAC Codes" />
                                    </div>
                                    <div className="gst-content">
                                        <h3>3. Allocation of HSN and SAC Codes</h3>
                                        <p>The <strong>Harmonized System of Nomenclature (HSN)</strong> for goods and <strong>Service Accounting Codes (SAC)</strong> for services are the backbone of GST classification.</p>
                                        <ul>
                                        <li>Identifying the correct HSN/SAC code for your goods or services.</li>
                                        <li>Allocating these codes in your accounting software for seamless GST compliance.</li>
                                        <li>Ensuring proper linkage between codes, descriptions, and applicable tax rates.</li>
                                        </ul>
                                    </div>
                                    </div>

                                    <div className="gst-card reverse">
                                    <div className="gst-icon">
                                        <img src="/images/gst-classification.jpg" alt="Notifications" />
                                    </div>
                                    <div className="gst-content">
                                        <h3>4. GST Classification of Goods as Per Notifications</h3>
                                        <p>The GST Council regularly updates notifications and schedules regarding the classification of goods. Our services include:</p>
                                        <ul>
                                        <li>Identifying goods needing classification.</li>
                                        <li>Mapping goods to appropriate <strong>sections and chapters</strong> in the tariff schedule.</li>
                                        <li>Determining the <strong>8-digit classification</strong> for goods.</li>
                                        <li>Assigning the relevant sub-heading and description from the GST rate schedule.</li>
                                        <li>Applying the correct tax rate as per the notification.</li>
                                        </ul>
                                    </div>
                                    </div>

                                    <div className="gst-card">
                                    <div className="gst-icon">
                                        <img src="/images/card-industry-specific-erp.webp" alt="Industry Specific" />
                                    </div>
                                    <div className="gst-content">
                                        <h3>5. Industry-Specific Classification Support</h3>
                                        <p>We offer tailored solutions for industries with unique classification challenges:</p>
                                        <ul>
                                       <li><strong>Pharmaceuticals:</strong> Identifying exemptions for life-saving drugs and medical equipment.</li>
                                       <li><strong>Real Estate:</strong> Classifying works contracts and construction activities.</li>
                                       <li><strong>E-commerce and Retail:</strong> Correctly categorizing a wide range of goods and services.</li>
                                       <li><strong>Hospitality and Food Services:</strong> Classification of bundled services such as accommodation and food.</li>
                                       <li><strong>Exports and Imports:</strong> Zero-rated supplies and compliance with cross-border transaction rules.</li>
                                        </ul>
                                    </div>
                                    </div>

                                    <div className="gst-card reverse">
                                    <div className="gst-icon">
                                        <img src="/images/review.jpg" alt="Review & Rectification" />
                                    </div>
                                    <div className="gst-content">
                                        <h3>6. Review and Rectification</h3>
                                        <p>We review your existing GST classification framework to identify and rectify errors, ensuring:</p>
                                        <ul>
                                        <li>Correct application of tax rates.</li>
                                        <li>Alignment between GST returns and financial records.</li>
                                        <li>Prevention of notices or disputes from GST authorities.</li>
                                        </ul>
                                    </div>
                                    </div>

                                    <div className="gst-card">
                                    <div className="gst-icon">
                                        <img src="/images/exemption.webp" alt="Exemptions" />
                                    </div>
                                    <div className="gst-content">
                                        <h3>7. Handling Exemptions and Concessional Rates</h3>
                                        <p>We assist in identifying exemptions and concessional rates applicable to your goods or services.</p>
                                        <ul>
                                        <li>Reviewing eligibility for exemptions or reduced rates.</li>
                                        <li>Advising on how to claim these benefits effectively.</li>
                                        </ul>
                                    </div>
                                    </div>

                                </div>
                            </section>

                            <div className="check_list_wrap mt-2 compliance_checklist_flow">
                                <h4 className="mt-2 mb-4">Our <sapn className="key_features">Approach</sapn></h4>
                                <div className="checklist-flow">
                                    <div className="checklist-item">
                                        <div className="check-content">
                                            <strong>1. Understanding Your Business:</strong>We analyze your products, services, and business operations to understand their nature and taxability.
                                        </div>
                                    </div>

                                    <div className="checklist-item">
                                        <div className="check-content">
                                            <strong>2. Applying Legal Expertise: </strong>Our GST experts stay updated on the latest GST notifications and regulations to ensure accurate classification.
                                        </div>
                                    </div>

                                    <div className="checklist-item">
                                        <div className="check-content">
                                            <strong>3. Documentation and Automation: </strong>We integrate HSN/SAC codes into your accounting software, streamlining tax reporting and compliance.
                                        </div>
                                    </div>

                                    <div className="checklist-item">
                                        <div className="check-content">
                                            <strong>4. Ongoing Support: </strong>Regular updates and proactive advice to address classification challenges and changes in GST laws.
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <h4 className="mt-5 mb-3">Key <sapn className="key_features">Features</sapn></h4>
                                <ol className="gst-feature-list row g-2">
                                    <li className="gst-feature-item col-lg-4 col-md-6 col-12">
                                        <div className="icon-emoji">🎯</div>
                                        <div className="text">
                                        <strong>Accuracy:</strong>
                                        Precise classification of goods and services to ensure compliance with applicable GST rates.
                                        </div>
                                    </li>
                                    <li className="gst-feature-item col-lg-4 col-md-6 col-12">
                                        <div className="icon-emoji">🧩</div>
                                        <div className="text">
                                        <strong>Tech Integration:</strong>
                                        Automation of classification through integration with accounting software.
                                        </div>
                                    </li>
                                    <li className="gst-feature-item col-lg-4 col-md-6 col-12">
                                        <div className="icon-emoji">🛡️</div>
                                        <div className="text mb-4">
                                        <strong>Risk Mitigation:</strong>
                                        Avoidance of penalties, disputes, and interest due to misclassification.
                                        </div>
                                    </li>
                                    <li className="gst-feature-item col-lg-4 col-md-6 col-12">
                                        <div className="icon-emoji">💸</div>
                                        <div className="text">
                                        <strong>Exemption Benefits:</strong>
                                        Identification of exempt or concessional supplies for cost optimization.
                                        </div>
                                    </li>
                                    <li className="gst-feature-item col-lg-4 col-md-6 col-12">
                                        <div className="icon-emoji">📊</div>
                                        <div className="text">
                                        <strong>Industry Expertise:</strong>
                                        Customized classification support tailored to your sector-specific needs.
                                        </div>
                                    </li>
                                </ol>
                            </div>

                             <div className='why_choose_vanani_bg mt-5'>
                                <div className='col-md-12'>
                                    <div className='check_list_wrap mt-1'>
                                        <h4 className='mt-2 mb-2'>Why Choose <sapn className="key_features">Vanani & Associates?</sapn></h4>
                                        <li className='mt-4'>With a team of seasoned GST experts and deep industry insights, <strong>Vanani & Associates</strong> ensures that your GST classification is error-free and aligned with the latest regulatory requirements. Our commitment to accuracy and compliance helps your business operate seamlessly in today’s complex tax environment.</li>
                                        <li className='mt-2 mb-2'><strong>Get in touch today to ensure your GST classification is precise and compliant!</strong></li>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default GST_Classification_Services;